import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataSharingService } from '../services/data-sharing.service';
import { Setting } from '../models/settings';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  price8Hour: string = '';
  price4Hour: string = '';

  constructor(private _router: Router, private _dataService: DataSharingService) { }

// onlineTrainingClick() {
//    this._dataService.setCourseDeliveryType('online');
//   this._dataService.setRegisterProgress('1');
//    this._router.navigate(['mhs-login']);
//  }

  classroomTrainingClick() {
    this._dataService.setCourseDeliveryType('classroom');
    this._dataService.setRegisterProgress('1');
    this._router.navigate(['mhs-login']);
  }

  ngOnInit() {
    this._dataService.getSetting('Price', 'price4Hour')
      .subscribe(
      res => this.getSetting4Succsess(res),
      error => this.getSettingFailure(error),
      () => console.log('Get Locations Complete!'));
    this._dataService.getSetting('Price', 'price8Hour')
      .subscribe(
      res => this.getSetting8Succsess(res),
      error => this.getSettingFailure(error),
      () => console.log('Get Locations Complete!'));
  }
  getSetting4Succsess(result: any) {
    const setting = result[0] as Setting;
    this.price4Hour = setting.description;
  }
  getSetting8Succsess(result: any) {
    const setting = result[0] as Setting;
    this.price8Hour = setting.description;
  }
  getSettingFailure(error: any) {
    return 'error';
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts